import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";

export default function ArrowDropDownMediumRoundedIcon() {
  return <ArrowDropDownRoundedIcon fontSize="medium" />;
}
